module.exports = __webpack_public_path__ + "static/media/lion_sword.f4ff6113.png";